// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-avenue -> weidner-apartment-homes-avenue -> fresco
// Generated: 2026-10-27T17:07:27.337Z
// Counts: 1 design, 37 content, 22 slot group, 1 collection binding, 11 section, 0 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_full_address"
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "<p>All Rights Reserved. <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_interactivemap_blurb"
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": "virtual tour",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_name"
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=48/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.inject_dni_classes": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Contact Us",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "cort-lead-form.form_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_cort_lead_form_id"
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a closer look at what makes Fresco Apartment Homes unique in Moreno Valley, CA. From bright kitchens perfect for meal prep to sun-filled living rooms and peaceful courtyard spaces, every photo captures the relaxed feeling you’ll find here. Start daydreaming about coffee on your private patio or game nights in the resident lounge, then schedule a tour to see it all for yourself.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "header.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>Pit Bull &amp; Pit Bull Mixes</p></li><li><p>American Pit Bull Terrier</p></li><li><p>American Staffordshire Terrier</p></li><li><p>Wolf Hybrids</p></li><li><p>Doberman Pinscher</p></li><li><p>Saint Bernard</p></li><li><p>American Bulldog</p></li><li><p>Staffordshire Bull Terrier</p></li><li><p>Rottweiler</p></li><li><p>German Shepherd</p></li><li><p>Chow Chow</p></li><li><p>Great Dane</p></li><li><p>Akita</p></li></ul><p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Step inside Fresco Apartment Homes and discover the comforts of in-home features like walk-in closets, an in-unit washer/dryer, and a built-in office desk. Outside your door, unwind by one of two sparkling pools, grill on a sunny weekend, or meet friends at the resident lounge. Every amenity is designed to bring a little more ease and fun to your days in Moreno Valley.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Reach out to our leasing team at Fresco Apartment Homes in Moreno Valley, CA. We’re here to answer your questions, help schedule your tour, and make your move as simple as possible. Expect a helpful response from our friendly, professional team, ready to assist you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Discover open layouts and smartly designed living spaces at Fresco Apartment Homes in Moreno Valley, CA. Our floor plans offer one, two, and three bedroom layouts so you’ll have room for your lifestyle - whether you need a cozy spot, extra space for remote work, or additional storage in multiple walk-in closets, Fresco has what you need. Many homes include private patios or balconies for fresh air mornings, plus a built-in office desk to keep life organized.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "frc-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Future Residents Club",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Living at Fresco Apartment Homes means having Moreno Valley right at your fingertips. Spend weekends at Moreno Valley Mall and TownGate Crossing with dozens of restaurants and major stores like Target and Macy’s. Costco and WinCo are just around the corner for those big grocery trips. Proximity to Freeway 60 puts downtown and beyond within easy reach, while nearby public transportation connects you to the heart of the city. Whether you love shopping, outdoor strolls, or meeting friends for coffee, everything you need is close to your new home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Looking for apartments for rent in Moreno Valley, CA? Fresco Apartment Homes invites you to relax into a life of modern comfort, with an outdoor pool glistening under the California sun, and free on-site parking for every resident. Enjoy the energy of nearby downtown Moreno Valley, with shopping at Moreno Valley Mall and easy access to Freeway 60. Experience pet-friendly spaces, in-home washer/dryers, and community amenities that make every day feel just a little easier.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to picture yourself living at Fresco? Schedule a friendly, personalized in-person tour with our leasing team to explore beautiful homes and community amenities at your own pace. We’re ready to answer all of your questions and ensure your tour experience is smooth and low-pressure. Touring restrictions may apply.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Can’t make it in person? Experience life at Fresco Apartments online. Our virtual tour lets you explore inviting layouts and the welcoming atmosphere from wherever you are. Take your time and picture mornings on your patio, or evenings spent relaxing in thoughtfully designed living spaces. When you’re ready, schedule an on-site visit to see how Fresco feels in person.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.repli360.com"
      }
    }
  },
  "footer.powered_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/5715369763274752/019d01a1-3f7d-77af-9dea-e6206da4f134.webp"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://www.multihub.io"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "footer.love_notes_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d44f3-3412-75a9-9aac-8f5678cb59df.webp"
      }
    }
  },
  "footer.weidner_cares_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d44f3-3452-767e-8966-83b6939f057f.webp"
      }
    }
  },
  "footer.youtube_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.youtube.com/@WeidnerApartmentHomes"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      }
    }
  },
  "_template:hyperlocal::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 10,
    "fieldOverrides": null
  },
  "contact-hero.bg_image": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "frc-hero.bg_image": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d08c1-76f9-7018-8382-79aef437748f.webp"
      }
    }
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": 22,
    "fieldOverrides": null
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": 20,
    "fieldOverrides": null
  },
  "resident-access-hero.bg_image": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 17,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "ec_817e837d10785bba5fef377e"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      1
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "cort-lead-form",
      "blockId": "cort-lead-form",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 11
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 11
    }
  ]
};

export const styleOverrides = {};
